'use client';
import React from 'react';
import { useWatch } from "react-hook-form";
import Overlay from "../shared/Overlay.jsx";
import Wrapper from "../shared/Wrapper.jsx"
import useMioForm from "../shared/useMioForm.jsx"
import { useEffect, useRef, useState } from "react";
import { PiCalendarDots, PiArrowCircleRightBold, PiArrowCircleLeftBold } from "react-icons/pi";
import { addDays, format, endOfISOWeek, startOfISOWeek, endOfMonth, startOfMonth, getMonth, parseISO, isValid, addMonths, daysToWeeks } from 'date-fns';

function MioDate(p) {
    // console.warn('date render');
    const { mioID, field, isDirty, isInvalid, isTouched, setValue } = useMioForm(p.name, p.required);
    // Step: watch the value, so we can populate the dummy input
    const value = useWatch({ name: p.name });
    // Step: focusRef is the dummy input field, which is used instead of the normal input date
    const focusRef = useRef();
    // Step: handle the overlay
    const [open, setOpen] = useState(false);
    const anchorRef = useRef();



    const [referenceDate, setReferenceDate] = useState(null);

    const [calendar, setCalendar] = useState(null);
    useEffect(() => {
        if (open) {
            focusRef.current.blur();
            // referenceDate is either value or today

            const today = format(new Date(), 'yyyy-MM-dd');
            const start = startOfISOWeek(startOfMonth(referenceDate));
            const end = endOfISOWeek(endOfMonth(referenceDate));
            const days = [];
            for (let date = start; date < end; date = addDays(date, 1)) {
                days.push({
                    display: format(date, 'dd'),
                    date: format(date, 'yyyy-MM-dd'),
                    off: getMonth(date) !== getMonth(referenceDate),
                    selected: format(date, 'yyyy-MM-dd') === value,
                    today: format(date, 'yyyy-MM-dd') === today
                })
            }
            setCalendar({ info: format(referenceDate, 'MMMM yyyy'), days })
        }
    }, [open, referenceDate])



    const dayClick = (e, row) => {
        e.stopPropagation(); // Stop default overlay behaviour
        field.onChange(row.date);
        portalClose();
    }

    const inputBlur = (event) => {
        if (event.target.value !== field.value) field.onChange(event.target.value);
    }

    const openCalendar = (e, offset) => {
        if (offset === 0) {
            const currentValue = parseISO(value ?? '');
            const currentValueCheck = isValid(currentValue) ? currentValue : new Date();
            setReferenceDate(currentValueCheck);
            setOpen(true);
        } else {
            e.stopPropagation();
            setReferenceDate(curr => addMonths(curr, offset));
        }
    }

    // focusRef is the element that gets the focuse after portal is closed

    const portalClose = () => {
        setOpen(false);
        focusRef.current?.focus();
    }

    useEffect(() => {
        const parsedValue = parseISO(value?.slice(0, 10) ?? '');
        const newValue = isValid(parsedValue) ? format(parsedValue, 'yyyy-MM-dd') : null;
        if (parsedValue !== newValue) setValue(p.name, newValue);
        focusRef.current.value = newValue;
    }, [value]);

    return (
        <>
            <Wrapper {...p} mioID={mioID} isInvalid={isInvalid} isTouched={isTouched} isDirty={isDirty}>
                <div className="mtwi" ref={anchorRef}>
                    {/* Dummy input to handle date conversions */}
                    {/* <input
                        {...field}
                        value={field.value ?? ''}
                        style={{ display: 'none' }}
                    /> */}
                    {/* {isDirty ? 'dirty' : 'nope'} */}
                    {/* Actual input */}
                    <input
                        className={`mio-form-control-input
                                         ${p.tabular && 'tabular'}
                                         ${isInvalid ? 'mio-form-control-input-invalid ' : ''}
                            `}
                        id={mioID}
                        placeholder={p.placeholder}
                        autoComplete="off"
                        ref={focusRef}
                        onBlur={inputBlur}
                        onKeyDown={(e) => { if (e.key === 'Enter') openCalendar(e, 0) }}
                    />
                    <div className="mio-form-control-icon" onClick={(e) => openCalendar(e, 0)}>
                        <PiCalendarDots />
                    </div>
                </div>
            </Wrapper >
            {open && <Overlay onClose={portalClose} anchorRef={anchorRef}>
                {calendar ? <>
                    <div className="mtwc">
                        {/* Date display and navigation */}
                        <div className="mtwc-header">
                            <div className="mtwc-arrow" onClick={(e) => openCalendar(e, -1)}>
                                <PiArrowCircleLeftBold />
                            </div>
                            <div className="mtwc-title">
                                {calendar.info}
                            </div>
                            <div className="mtwc-arrow" onClick={(e) => openCalendar(e, +1)}>
                                <PiArrowCircleRightBold />
                            </div>
                        </div>

                        <div className="mtwc-days">
                            <div className="mtwc-weekday">Mon</div>
                            <div className="mtwc-weekday">Tue</div>
                            <div className="mtwc-weekday">Wed</div>
                            <div className="mtwc-weekday">Thu</div>
                            <div className="mtwc-weekday">Fri</div>
                            <div className="mtwc-weekday">Sat</div>
                            <div className="mtwc-weekday">Sun</div>
                            {calendar.days.map((row, index) => (
                                <div className={`
                                mio-form-calendar-day mtwc-day
                                ${row.off ? 'mio-form-calendar-day-off mtwc-off' : ''}
                                ${row.selected ? 'mio-form-calendar-day-selected mtwc-selected' : ''}
                                ${row.today ? 'mio-form-calendar-day-today mtwc-today' : ''}
                                `} key={index} onClick={(e) => dayClick(e, row)}>
                                    {row.display}
                                </div>))}
                        </div>
                    </div>

                </> : 'Loading'}
            </Overlay>}
        </>
    )
}
export default MioDate